import React from 'react'
import { StyleSheet, View } from 'react-native'
import { Card, Text } from 'react-native-paper'
import { useNavigation } from '@react-navigation/native'
import { AppNavigation } from '../../../../navigation/types'
import { NodeTopUsersQuery } from '../../../../generated/graphql'
import Row from '../../../../@ui/containers/grid/row'
import Column from '../../../../@ui/containers/grid/column'

interface UserStatRowProps {
  userWithCoRank: NodeTopUsersQuery['nodeTopUsers']['users'][0]
  rank: number
}

export function UserStatRow({ userWithCoRank, rank }: UserStatRowProps) {
  const navigation = useNavigation<AppNavigation>()
  const { user, coRank } = userWithCoRank

  const handlePress = () => {
    navigation.navigate('Profile', { userId: user.id })
  }

  return (
    <Card style={styles.card} onPress={handlePress}>
      <Card.Content style={styles.content}>
        <View style={styles.rankSection}>
          <Text variant="labelLarge" style={styles.rankText}>
            #{rank}
          </Text>
        </View>
        <View style={styles.mainSection}>
          <Text variant="titleMedium" style={styles.username} numberOfLines={1}>
            {user.username}
          </Text>
        </View>
        <View style={styles.statsSection}>
          <Text variant="bodySmall" style={styles.label}>
            CoRank
          </Text>
          <Text variant="titleLarge">{coRank.toFixed(2)}</Text>
        </View>
      </Card.Content>
    </Card>
  )
}

const styles = StyleSheet.create({
  card: {
    marginBottom: 8,
  },
  content: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
  },
  rankSection: {
    marginRight: 12,
    minWidth: 40,
    alignItems: 'center',
  },
  rankText: {
    fontWeight: '600',
    textAlign: 'center',
  },
  mainSection: {
    flex: 1,
    marginRight: 16,
  },
  username: {
    fontWeight: '500',
    color: '#2196F3',
    textDecorationLine: 'underline',
  },
  statsSection: {
    alignItems: 'center',
    minWidth: 60,
  },
  label: {
    opacity: 0.6,
    marginBottom: 4,
  },
})
